"use client";

import React from "react";
import { ArrowRight, Bot, Coffee, Play, Sparkles, Users, WandSparkles, Wifi } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const processSteps = [{
  subtitle: "PRÄSENTATION.",
  title: "Dein Pitch, groß auf dem Screen.",
  description: "Großer Präsentationsbildschirm. Anschließen, präsentieren. Kein Adapter-Bingo.",
  icon: Bot
}, {
  subtitle: "KREATIVITÄT.",
  title: "Ideen, die an der Wand kleben.",
  description: "Whiteboard. Für alles, was mit Stift besser funktioniert als mit Slides.",
  icon: WandSparkles
}, {
  subtitle: "KAPAZITÄT.",
  title: "Platz für bis zu 8 Köpfe.",
  description: "Genug Raum für echte Gespräche. Nicht zu groß, nicht zu klein.",
  icon: Play
}, {
  subtitle: "KONNEKTIVITÄT.",
  title: "Internet, das nie bremst.",
  description: "Highspeed-WLAN. Für Videocalls, Screen-Sharing und alles gleichzeitig.",
  icon: Wifi
}, {
  subtitle: "VERPFLEGUNG.",
  title: "Kaffee steht schon bereit.",
  description: "Getränke inklusive. Kaffee, Tee, Wasser — steht bereit, wenn ihr ankommt.",
  icon: Coffee
}, {
  subtitle: "PARKEN.",
  title: "Direkt vor der Tür parken.",
  description: "Kostenlose Parkplätze direkt am Gebäude. Für dich und deine Gäste.",
  icon: Users
}];
export default function HeroSection() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="184567" id="features" className="bg-[#EEEEEE] ![padding:144px_0px_144px_0px]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-12">
        {/* Left: Header */}
        <div ref={headerRef} className={`flex flex-col justify-between transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div>
            <span className="text-sm font-semibold uppercase tracking-widest text-[#888888] mb-4 block">Ausstattung</span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6">
              <span className="text-[#141414]">Alles drin.</span><br />
              <span className="text-[#888888]">Damit du dich auf den Inhalt konzentrierst.</span>
            </h2>
          </div>
          <div>
            <div className="flex flex-wrap gap-2 mb-6">
              <span className="inline-block rounded-full bg-[#141414]/5 border border-[#141414]/10 px-4 py-2 text-sm font-medium text-[#555555]">Technik</span>
              <span className="inline-block rounded-full bg-[#141414]/5 border border-[#141414]/10 px-4 py-2 text-sm font-medium text-[#555555]">Komfort</span>
            </div>
            <p className="text-base text-[#555555] leading-relaxed">
              Kein Kabelsalat. Kein Beamer, der nicht will. Kein Raum, der nach dem letzten Meeting noch müffelt. Einfach reingehen und loslegen.
            </p>
          </div>
        </div>

        {/* Right: Feature Grid */}
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-2 gap-4 transition-all duration-1000 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {processSteps.map((step, i) => {
            const Icon = step.icon;
            return <div key={i} data-index={i} className="group rounded-2xl bg-white/60 backdrop-blur-sm p-8 transition-all duration-300 hover:bg-white hover:shadow-lg cursor-default">
                <div className="flex items-center gap-3 mb-3">
                  <Icon className="size-4 text-[#FF6F61]" />
                  <span className="text-xs font-semibold uppercase tracking-widest text-[#FF6F61]">
                    {step.subtitle}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-[#141414] mb-4">
                  {step.title}
                </h3>
                <p className="text-sm leading-relaxed text-[#555555]">
                  {step.description}
                </p>
              </div>;
          })}
        </div>
      </div>
    </div>
  </section>;
}